import { VenereBox, VenereButton } from '../../shared/ui';
import { useVenereAppointments } from '../hooks';

export const VenereConsultsSummary = () => {
    const {
        appointments,
        futureAppointments,
        pastAppointments,
        specialistAppointments,
        nutritionistAppointments,
        totalAppointments,
        upcomingCount,
        pastCount,
        isLoading,
        error,
    } = useVenereAppointments();

    if (isLoading) {
        return (
            <VenereBox variant="seasalt" className="p-6">
                <div className="flex items-center justify-center">
                    <div className="w-8 h-8 border-4 border-venere-royal border-t-transparent rounded-full animate-spin"></div>
                </div>
            </VenereBox>
        );
    }

    if (error) {
        return (
            <VenereBox variant="seasalt" className="p-6">
                <div className="text-center text-red-500">
                    Errore nel caricamento degli appuntamenti: {error.message}
                </div>
            </VenereBox>
        );
    }

    if (futureAppointments.length === 0) {
        return null
    }

    return (
        <div className="flex flex-col gap-4 items-center">
            <div className="venere-text-primary">Programmati</div>
            {
                futureAppointments.map((appointment) => (
                    <VenereBox variant='matcha' className='w-full'>
                        <div className='flex flex-col gap-4'>
                            <div className='flex gap-2 items-center'>
                                <img src={appointment.expert.calendly_data.calendly_user.avatar_url} alt={appointment.expert.calendly_data.calendly_user.name} className='w-10 h-10 rounded-full' />
                                <div>
                                    <div>Consulto medico</div>
                                    <div>{appointment.expert.calendly_data.calendly_user.name}</div>
                                    <div>{ }</div>
                                    <div className='venere-text-purple' onClick={() => window.open(appointment.editUrl, '_blank')}>Modifica</div>
                                </div>
                                <div className='venere-text-royal' onClick={() => window.open(appointment.cancelUrl)}>CANCELLA</div>

                            </div>
                            <VenereButton onClick={() => window.open(appointment.connectUrl, '_blank')}>
                                Connettiti
                            </VenereButton>
                        </div>
                    </VenereBox>
                ))
            }
        </div>
    )
}; 